import React from "react"
import dataLayerHelper from "../../helpers/datalayer.helper"
import { ArticleTag, TagWrapper } from "./blog-tag.styles"
const BlogTag = ({ blogPost, label, value, onTagChange, slug }) => {

  const url = `/blog/library/?tag=${value}${label.includes("Monthly") ? "#monthly" : "#recent"
    }`
  let slugPrefix
  blogPost.tags.map((newTag) => {
    slugPrefix = newTag.isNewsletterTag ? "/newsletters/" : "/blog/library/"
  })

  return (
    <TagWrapper
      style={{ textDecoration: "none" }}
      to={`${slugPrefix}${slug}`}
      onClick={() => {
        dataLayerHelper({
          event: "blogPostCardClick",
          action: "Blog Tag Click",
          label: `Label: ${label}`,
        })
      }}
    >
      <ArticleTag
        key={label}
      >
        <span className="articleTag">{label}</span>
      </ArticleTag>
    </TagWrapper>
  )
}
export default BlogTag
